import { render, staticRenderFns } from "./AddProductToCart.vue?vue&type=template&id=bb0c3ac0&scoped=true"
import script from "./AddProductToCart.vue?vue&type=script&lang=js"
export * from "./AddProductToCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0c3ac0",
  null
  
)

export default component.exports